module.exports = __webpack_public_path__ + "4e2fb7f79a2d4db66be9bb1a37564386.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-black.png
// module id = 2492
// module chunks = 0